import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=3a6d8f7a&"
import script from "./Sale.vue?vue&type=script&lang=js&"
export * from "./Sale.vue?vue&type=script&lang=js&"
import style0 from "./Sale.vue?vue&type=style&index=0&id=3a6d8f7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports